/* eslint-disable jsdoc/require-jsdoc */

import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/:id',
    name: 'Home',
    component: () => import('@/views/HomePage.vue'),
    meta: { layout: 'main', auth: true },
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/ErrorPage.vue'),
  },
  {
    path: '/success',
    name: 'Success',
    component: () => import('@/views/SuccessPage.vue'),
  },
  {
    path: '/completed',
    name: 'Completed',
    component: () => import('@/views/CompletedPage.vue'),
  },
  {
    path: '/expired',
    name: 'Expired',
    component: () => import('@/views/ExpiredPage.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active',
  linkExactActiveClass: 'active',
})

router.beforeEach((to, from, next) => {
  const requireAuth = to.meta.auth

  if (requireAuth) {
    return next()
  }

  next()
})

export default router
